import { dequal } from 'dequal';
import React, { useCallback, useContext, useMemo, useReducer, useEffect } from 'react';

const KpiContext = React.createContext();

export const DATA_READY = 'DATA_READY';

const KpiReducer = (state, action) => {
    switch (action.type) {
        case DATA_READY:
            return { ...state, ...action.payload };
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
};

const KpiProvider = ({ defaultValues, ...restProps }) => {
    const [state, dispatch] = useReducer(KpiReducer, {
        ...defaultValues
    });
    const kpiData = useMemo(() => state, [state]);
    const dispatchAction = useCallback((...args) => dispatch(...args), [dispatch]);

    useEffect(() => {
        if (dequal(state, kpiData)) {
            dispatchAction({ type: DATA_READY, payload: defaultValues });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValues]);

    return <KpiContext.Provider value={{ kpiData, dispatch: dispatchAction }} {...restProps} />;
};

const useKpi = () => {
    const context = useContext(KpiContext);
    if (!context) {
        throw new Error('useKpi must be used within a KpiProvider');
    }
    return context;
};

export { KpiProvider, useKpi };
